import React, { useState } from "react";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import Box from "@mui/material/Box";
import ListItemText from "@mui/material/ListItemText";
import Collapse from "@mui/material/Collapse";
import TitleBar from "../../components/TitleBar";
import DraftsIcon from "@mui/icons-material/Drafts";
import EmailIcon from "@mui/icons-material/Email";
import useScrollToTop from "../../components/CustomHooks/useScrollToTop";

function MessagesPage() {
  useScrollToTop();

  const [expanded, setExpanded] = useState({});
  const [clicks, setClicks] = useState([]);
  const loginResponse = JSON.parse(localStorage.getItem("loginResponse"));
  let messages = [];
  let client_id;
  let localStorageKey = "";

  if (loginResponse) {
    messages = loginResponse.broadcast_message;
    client_id = loginResponse.client_id;
    localStorageKey = `broadcastedMessages_${client_id}`;
  }

  const handleClick = (id, time_end) => {
    setExpanded({ ...expanded, [id]: !expanded[id] });
    if (!clicks.includes(id)) setClicks([...clicks, id]);
    else clicks.pop(id);

    let storedMessages =
      JSON.parse(localStorage.getItem(localStorageKey)) || [];
    const readMessage = {
      POST_ID: id,
      TIME_END: time_end,
    };

    if (
      !storedMessages.some(
        (val) =>
          val.POST_ID === readMessage.POST_ID &&
          val.TIME_END === readMessage.TIME_END
      )
    ) {
      storedMessages.push(readMessage);
      localStorage.setItem(localStorageKey, JSON.stringify(storedMessages));
    }
  };

  return (
    <div className="container" style={{ marginTop: "30px" }}>
      <TitleBar title="Messages" />
      <Box display="flex" textOverflow="ellipsis" justifyContent="center">
        {Object.entries(messages).length > 0 && (
          <List
            component="nav"
            dense
            sx={{
              width: "100%",
              maxWidth: 720,
              position: "relative",
              overflow: "auto",
              maxHeight: "auto",
              marginBottom: "70px",
            }}
            style={{ border: "solid 1px #ACACAC", borderRadius: "5px" }}
          >
            {Object.values(messages).map((message) => {
              return (
                <div key={message.POST_ID}>
                  <ListItem
                    key={message.POST_ID}
                    button
                    divider
                    onClick={() =>
                      handleClick(message.POST_ID, message.TIME_END)
                    }
                  >
                    <ListItemIcon>
                      {clicks.includes(message.POST_ID) ? (
                        <DraftsIcon />
                      ) : (
                        <EmailIcon />
                      )}
                    </ListItemIcon>
                    <ListItemText
                      sx={{
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                      primary={`${message.POST_TITLE} - ${message.TIME_START} `}
                      secondary={message.POST_CONTENT}
                    />
                  </ListItem>
                  <Collapse
                    in={expanded[message.POST_ID]}
                    timeout="auto"
                    unmountOnExit
                  >
                    <List component="div" disablePadding>
                      <ListItem
                        key={message.POST_ID}
                        sx={{
                          paddingLeft: 4,
                        }}
                      >
                        <ListItemText primary={message.POST_CONTENT} />
                      </ListItem>
                    </List>
                  </Collapse>
                </div>
              );
            })}
          </List>
        )}
        {Object.entries(messages).length === 0 && (
          <div>No Messages on file</div>
        )}
      </Box>
    </div>
  );
}

export default MessagesPage;
